export default __webpack_public_path__ + "static/media/athleteBasketballhoop.e411608d.jpg";